import { PropertyApiService } from '@admin/core';
import { UnmanagedPropertyLateRecord } from '@admin/core/models';
import { Component, inject } from '@angular/core';
import { CacBaseDialogComponent, CacDialogLayoutComponent, CacTableComponent, GetOfflineAdapter, table } from '@controladad/ng-base';
import { BehaviorSubject, switchMap, tap } from 'rxjs';

export type LateRecordsDialogData = UnmanagedPropertyLateRecord[];
export type LateRecordsDialogResult = never;

@Component({
  selector: 'app-late-records-dialog',
  imports: [CacDialogLayoutComponent, CacTableComponent],
  templateUrl: './late-records-dialog.component.html',
})
export class LateRecordsDialogComponent extends CacBaseDialogComponent<
  LateRecordsDialogData,
  LateRecordsDialogResult
> {
  private readonly propertyApi = inject(PropertyApiService);

  records$ = new BehaviorSubject<UnmanagedPropertyLateRecord[]>(this.data);

  table = table({
    itemsFn: GetOfflineAdapter(this.records$),
    columns: {
      managedDate: { label: 'تاریخ اموال گردانی', type: 'datetime' },
      syncedAt: { label: 'تاریخ سینک اموال گردانی', type: 'datetime' },
      auditorFullName: { label: 'اموال گردان' },
      syncedByFullName: { label: 'سینک کننده دیتا' },
    },
    actions: [
      {
        type: 'button',
        content: 'افزودن ',
        class: 'w-36',
        action: (item: UnmanagedPropertyLateRecord) =>
          dialog$.prompt({
            title: 'تایید افزودن رکورد',
            message: 'آیا از افزودن این رکورد به رکوردهای برنامه اموال گردانی اطمینان دارید؟',
            yesButtonText: 'بله',
          }).afterSubmit().pipe(
            switchMap(() => this.propertyApi.approveLateAssetAudit(item.id)),
            tap(() => {
              snackbar$.show('با موفقیت تایید شد');
              const records = this.records$.value;
              this.records$.next(records.filter(x => x.id !== item.id));
              this.table.refresh();
            })
          )
      },
    ],
  });
}
